import { Button } from '@hakimo-ui/shared/ui-base';
import { PlusIcon } from '@heroicons/react/24/outline';
import SOPCard from './SOPCard';
import { renderEditableList, renderViewableList } from '../utils';
import { INPUT_PLACEHOLDERS } from '../constants';
import { createStringListHandlers } from './utils';

interface Props {
  escalationProtocol: string[];
  escalationPoints: string[];
  onProtocolChange: (val: string[]) => void;
  onPointsChange: (val: string[]) => void;
  isEditing: boolean;
  compact?: boolean;
}

export function SOPEscalationsCard(props: Props) {
  const {
    escalationProtocol,
    escalationPoints,
    onProtocolChange,
    onPointsChange,
    isEditing,
    compact,
  } = props;

  const {
    handleAdd: handleAddProtocol,
    handleEdit: handleProtocolChange,
    handleDelete: handleDeleteProtocol,
  } = createStringListHandlers(escalationProtocol, onProtocolChange);

  const {
    handleAdd: handleAddPoint,
    handleEdit: handlePointChange,
    handleDelete: handleDeletePoint,
  } = createStringListHandlers(escalationPoints, onPointsChange);

  return (
    <SOPCard title="Escalations" compact={compact}>
      <div className="space-y-8">
        {/* Escalation Protocol Section */}
        <div>
          <div className="mb-2 flex items-center justify-between">
            <h4 className="text-onlight-text-1 dark:text-ondark-text-1 font-medium">
              Protocol
            </h4>
            {isEditing && (
              <Button
                variant="primary"
                onClick={handleAddProtocol}
                className="flex items-center gap-2"
              >
                <PlusIcon className="h-4 w-4" />
                Add
              </Button>
            )}
          </div>
          {isEditing
            ? renderEditableList(
                escalationProtocol,
                handleProtocolChange,
                handleDeleteProtocol,
                INPUT_PLACEHOLDERS.ESCALATION_PROTOCOL
              )
            : renderViewableList(escalationProtocol, 'space-y-1')}
        </div>

        {/* Points to Remember Section */}
        <div>
          <div className="mb-2 flex items-center justify-between">
            <h4 className="text-onlight-text-1 dark:text-ondark-text-1 font-medium">
              Points to Remember
            </h4>
            {isEditing && (
              <Button
                variant="primary"
                onClick={handleAddPoint}
                className="flex items-center gap-2"
              >
                <PlusIcon className="h-4 w-4" />
                Add
              </Button>
            )}
          </div>
          {isEditing
            ? renderEditableList(
                escalationPoints,
                handlePointChange,
                handleDeletePoint,
                INPUT_PLACEHOLDERS.ESCALATION_POINT
              )
            : renderViewableList(escalationPoints, 'space-y-1')}
        </div>
      </div>
    </SOPCard>
  );
}

export default SOPEscalationsCard;
